export default __webpack_public_path__ + "static/media/eco-sub-image-04.4ac13ebf.png";